// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Nye","field":"styles_field__m23GI","fieldCol":"styles_fieldCol__1MsCz","diffCol":"styles_diffCol__vg3qf","diff":"styles_diff__2p8Fc"};